(() => {
(function($) {
    document.addEventListener("DOMContentLoaded", function(event) {
        const tableCourses = $("#courses-table");
        if (tableCourses.length) tableCourses.DataTable({
            lengthMenu: [
                [
                    10,
                    25,
                    50,
                    -1
                ],
                [
                    10,
                    25,
                    50,
                    "Tudo"
                ]
            ],
            dom: "Bfrtip",
            buttons: [
                "excel",
                "pageLength"
            ],
            ajax: {
                url: "/wp-admin/admin-ajax.php?action=lds_get_table_information"
            },
            ordering: false,
            serverSide: true,
            language: {
                "url": globalVars.datatables
            },
            columns: [
                {
                    data: "id"
                },
                {
                    data: "nome"
                },
                {
                    data: "created"
                },
                {
                    data: "total"
                },
                {
                    data: "not_started"
                },
                {
                    data: "in_progress"
                },
                {
                    data: "completed"
                },
                {
                    data: "tests_average"
                },
                {
                    data: "completed_average"
                },
                {
                    data: "detail"
                }
            ]
        });
    });
})(jQuery);


(function($) {
    document.addEventListener("DOMContentLoaded", function(event) {
        const tableUsers = $("#users-courses-table");
        if (tableUsers.length) {
            const coursesTable = tableUsers.DataTable({
                lengthMenu: [
                    [
                        10,
                        25,
                        50,
                        -1
                    ],
                    [
                        10,
                        25,
                        50,
                        "Tudo"
                    ]
                ],
                dom: "Bfrtip",
                buttons: [
                    "excel",
                    "pageLength"
                ],
                ajax: {
                    url: "/wp-admin/admin-ajax.php?action=lds_get_users_information",
                    data: function(data) {
                        data.date = $("#consulting-date").val();
                        data.course = $("#course-id").val();
                        return data;
                    }
                },
                serverSide: true,
                ordering: false,
                language: {
                    "url": globalVars.datatables
                },
                columns: [
                    {
                        data: "id"
                    },
                    {
                        data: "nome"
                    },
                    {
                        data: "email"
                    },
                    {
                        data: "status"
                    },
                    {
                        data: "tests_average"
                    },
                    {
                        data: "first_access"
                    },
                    {
                        data: "completed_date"
                    },
                    {
                        data: "completed_average"
                    },
                    {
                        data: "expected"
                    }
                ]
            });
            $("#consulting-date").on("change", function() {
                coursesTable.ajax.reload();
            });
        }
    });
})(jQuery);


(function($) {
    document.addEventListener("DOMContentLoaded", function(event) {
        const loader = $("#loader");
        if (loader.length) {
            $(document).ajaxStart(function() {
                loader.show();
            });
            $(document).ajaxStop(function() {
                loader.hide();
            });
        }
    });
})(jQuery);




})();
//# sourceMappingURL=index.js.map
